/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/launch'
export default icon
